import PopupShell from '@/Components/Map/PopupShell'
import { iconeGeometrie } from '@/Components/Map/featurePopupFormat'
import { useSafeTheme } from '@/theme/hooks'
import PropTypes from 'prop-types'

// Un resultat qui designe une couche entiere, pas une entite : pas d'attributs
// a montrer, juste de quoi savoir sur quoi la carte vient de se caler.
const SearchLayerPopup = ({ titre, sousTitre, geometryType, onClose }) => {
  const { theme } = useSafeTheme()

  return (
    <PopupShell
      titre={titre?.trim() || 'Couche'}
      icone={iconeGeometrie(geometryType)}
      onClose={onClose}
    >
      {sousTitre && (
        <p
          className="m-0 break-words px-3 py-3 text-[11px]"
          style={{ color: theme.text.tertiary }}
        >
          {sousTitre}
        </p>
      )}
    </PopupShell>
  )
}

SearchLayerPopup.propTypes = {
  titre: PropTypes.string,
  sousTitre: PropTypes.string,
  geometryType: PropTypes.string,
  onClose: PropTypes.func.isRequired,
}

export default SearchLayerPopup
